var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home w-100"},[_c('v-container',{staticClass:"main-container w-100 py-10"},[_vm._v(" Nothing to see here. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }